import React from 'react';

interface IProps {}

export const LoaderQuizScreenV15_0_5: React.FC<IProps> = () => {
	return (
		<>
			{styles}
			<section className='dummy'>
				<div className='dummy__header' />
				<div className='dummy__content'>
					<div className='dummy__title' />
					<div className='dummy__list'>
						<div className='dummy__item dummy-animation' />
						<div className='dummy__item dummy-animation' />
						<div className='dummy__item dummy-animation' />
					</div>
					<div className='dummy__button dummy-animation' />
				</div>
			</section>
		</>
	);
};

const styles = (
	<style>
		{`
			.dummy {
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				display: flex;
    		flex-flow: column;
				background-color: #fff;
				z-index: 999999;
				animation: dummy-shown 0.25s ease;
			}
			.dummy__header {
				flex-shrink: 0;
				position: relative;
				width: 100%;
				height: 56px;
				margin: 0 auto;
				background: linear-gradient(90deg, rgba(153,153,153, 0.1), rgba(153,153,153, 0.3), rgba(153,153,153, 0.1));
			}
			.dummy__content {
				flex: 1;
				width: 100%;
				display: flex;
    		flex-flow: column;
				max-width: 390px;
				margin: 32px auto 64px;
				padding: 0 20px;
			}
			@media (max-width: 767px) {
				.dummy__content {
					margin: 24px auto 56px;
				}
			}
			@media (max-width: 767px) {
				.dummy__content {
					margin: 24px auto 40px;
				}
			}
			.dummy__title {
				height: 90px;
			}
			.dummy__list {
				margin-top: 24px;
			}
			.dummy__item {
				height: 92px;
				border-radius: 10px;
				background: linear-gradient(90deg, rgba(153,153,153, 0.1), rgba(153,153,153, 0.3), rgba(153,153,153, 0.1));
			}
			.dummy__item:not(:last-child) {
				margin-bottom: 24px;
			}
			.dummy__button {
				margin-top: auto;
				width: 100%;
				height: 56px;
				border-radius: 10px;
				background: linear-gradient(90deg, rgba(153,153,153, 0.1), rgba(153,153,153, 0.3), rgba(153,153,153, 0.1));
			}
			.dummy-animation {
				background-size: 200%;
				animation: dummy-skeleton-animation 1.25s infinite reverse;
			}
			@keyframes dummy-shown {
				from {
					opacity: 0;
				}
				to {
					opacity: 1;
				}
			}
			@keyframes dummy-skeleton-animation {
					from {
						background-position: -100% 0;
					}
					to {
						background-position: 100% 0;
					}
				}
		`}
	</style>
);
